import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { AppRoute } from "../App";
import ScreenLoader from "./ui/ScreenLoader";

export const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if(isAuthenticated === null){
    return <ScreenLoader isLoading={true} />;
  }

  if (isAuthenticated === true) {
    return <Navigate to={AppRoute.Home} replace />;
  }

  return <>{children}</>;
}; 
